module.exports = __webpack_public_path__ + "static/media/gw.c70b84b8.svg";